import React from 'react';
import { isMoreLinkEvent } from 'modules/calendarv2/utils/eventFormatters';

const MultiMonthYearEventContent = ({ eventInfo, openDayEventsPopup }) => {
  if (isMoreLinkEvent(eventInfo.event)) {
    const onClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      openDayEventsPopup(eventInfo?.event?._def?.extendedProps?.date);
    };
    return (
      <a onClick={onClick} title={eventInfo.event.title} className="fc-daygrid-more-link fc-more-link custom-more-link">
        {eventInfo.event.title}
      </a>
    );
  }
  return <></>;
};

export default MultiMonthYearEventContent;
